import React, { useEffect } from 'react';
import './App.css';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import Cookies from 'js-cookie';
import Index from './pages';
import Desboard from './pages/desboard';
import Patient from './pages/Patients';
import Profile from './pages/Profile';
import { useNavigate } from 'react-router-dom';
import Screen4TestForm from './pages/FSForm';
import Screen4Details from './pages/clientDetails';
import Report from './pages/report';
import Analytics from './pages/newdashboard';
import JobRequestForm from './pages/jobRequestForm';
import JobRequests from './pages/jobRequest';
import JobRequestDetails from './pages/jobRequestUpdate';
import AddClientForm from './pages/addClientForm';
import AllClients from './pages/allClients';
import AllCollectors from './pages/AllCollectors';
import AddCollectorForm from './pages/addCollectorForm';
import BarcodeImageScanner from './components/test';
import ClientHub from './pages/ClientHub';
import RefusalForm from './pages/refusalform/RefusalForm';

function ScrollToTop() {
  const { pathname } = useLocation();
  const loginemail = Cookies.get("email");
  const loginname = Cookies.get("Name");
  const id = Cookies.get("id");
  const token = Cookies.get("Token");
  const navigate = useNavigate();

  useEffect(() => {
    window.scrollTo(0, 0);

    if (token === "sdrfg&78967daghf#wedhjgasj(dlsh6kjsdg") {
      var myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/x-www-form-urlencoded");

      var urlencoded = new URLSearchParams();
      urlencoded.append("_id", id);

      var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: urlencoded,
        redirect: 'follow'
      };

      fetch(`${process.env.REACT_APP_API_URL}/profileinfocheck`, requestOptions)
        .then(response => response.text())
        .then(result => {
          if (result === "deactivated") {
            const allCookies = Cookies.get();
            for (const cookieName in allCookies) {
              // Cookies.remove(cookieName);
            }
            navigate('/');
          }
        })
        .catch(error => console.log('error', error));
    }

  }, [pathname, navigate, token, id]);

  return null;
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <ScrollToTop />

        <Routes>
          <Route path='/' element={<Index />} />
          <Route path='/data' element={<Patient />} />
          <Route path='/jobrequests' element={<JobRequests />} />
          <Route path="/refusalform" element={<RefusalForm />} />
          <Route path='/dashboard/profile' element={<Profile />} />
          <Route path='/screen4testform' element={<Screen4TestForm />} />
          <Route path='/screen4testform2' element={<JobRequestForm />} />
          <Route path="/dashboard/:id" element={<Screen4Details />} />
          <Route path="/jobrequest/:id" element={<JobRequestForm />} />
          <Route path="/dashboard" element={<Analytics />} />
          <Route path="/report" element={<Report />} />
          <Route path="/clients" element={<AllClients />} />
          <Route path="/clients/:clientId" element={<ClientHub />} />
          <Route path="/clients/overview" element={<ClientHub />} />
          <Route path="/collectors" element={<AllCollectors />} />
          <Route path="/addclient" element={<AddClientForm />} />
          <Route path="/addcollector" element={<AddCollectorForm />} />
          <Route path="/addclient/:id" element={<AddClientForm />} />
          <Route path="/addcollector/:id" element={<AddCollectorForm />} />
          <Route path="/test" element={<BarcodeImageScanner />} />

          {/* Fallback - catch-all to avoid 'No routes matched' messages */}
          <Route path="*" element={<Index />} />
        </Routes>

      </BrowserRouter>
    </div>
  );
}

export default App;
